export default "__VITE_ASSET__0ddf1d40__"